import React from "react";
import { IIndustryResult } from "../../lib/models/IIndustryInsights";

export default function InsightResult(props) {
  const { data } = props;

  if (props.number === 0) {
    return (
      <div className="col-12 col-md-6 col-lg-12 results__card">
        <a href={data.url} target="_self">
          <div className={"insight-teaser image-left"}>
            <div
              className="image"
              style={{
                backgroundImage: `url(${data.teaserImageUrl}?width=575)`
              }}
              role="img"
              aria-label={data.teaserImageAltText}
            >
              {data.showTeaserPlayButton ? (
                <div className="play-button"></div>
              ) : null}
            </div>
            <div className="text">
              {data.teaserText && (
                <div className="teaser-type insight">
                  <p className="teaser-type__inner">{data.teaserText}</p>
                </div>
              )}
              <h4>{data.name}</h4>
              {data.readMoreText && (
                <p className="teaser-cta-text">
                  {data.readMoreText}
                  <i className="icon-chevron-right--darkish-pink"></i>
                </p>
              )}
            </div>
          </div>
        </a>
      </div>
    );
  }
  return (
    <div className="col-12 col-md-6 col-lg-4 results__card">
      <a href={data.url} target="_self">
        <div className={"insight-teaser image-top"}>
          <div
            className="image"
            style={{
              backgroundImage: `url(${data.teaserImageUrl}?width=575)`
            }}
            role="img"
            aria-label={data.teaserImageAltText}
          >
            {data.showTeaserPlayButton ? (
              <div className="play-button"></div>
            ) : null}
          </div>
          <div className="text">
            {data.teaserText && (
              <div className="teaser-type insight">
                <p className="teaser-type__inner">{data.teaserText}</p>
              </div>
            )}
            <h4>{data.name}</h4>
            {data.readMoreText && (
              <p className="teaser-cta-text">
                {data.readMoreText}
                <i className="icon-chevron-right--darkish-pink"></i>
              </p>
            )}
          </div>
        </div>
      </a>
    </div>
  );
}
